import { Helmet } from "react-helmet-async";

const SITE = "https://stabilor.hu";
const DEFAULT_IMAGE = `${SITE}/images/hero.png`;

export default function Seo({
    title,
    description,
    path = "/",
    image = DEFAULT_IMAGE,
    noindex = false,
    type = "website",
    breadcrumbs,
}) {
    const url = `${SITE}${path}`;
    const fullTitle = title.includes("Stabilor") ? title : `${title} — Stabilor`;

    const breadcrumbJsonLd = breadcrumbs && {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbs.map((b, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: b.name,
            item: `${SITE}${b.path}`,
        })),
    };

    return (
        <Helmet>
            <html lang="hu" />
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />
            {noindex ? (
                <meta name="robots" content="noindex, nofollow" />
            ) : (
                <meta name="robots" content="index, follow, max-image-preview:large" />
            )}

            {/* Open Graph */}
            <meta property="og:type" content={type} />
            <meta property="og:site_name" content="Stabilor" />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:locale" content="hu_HU" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={url} />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {breadcrumbJsonLd && (
                <script type="application/ld+json">
                    {JSON.stringify(breadcrumbJsonLd)}
                </script>
            )}
        </Helmet>
    );
}
